import axios from 'axios';
import { onForbidden } from '../App';
import getDefaultHeaders from "../utils/axios/getDefaultHeaders";
import verifyJWT from "../utils/axios/verifyJWT";

const axiosInstances: any = {};

const apiUrl = process.env.REACT_APP_API_URL || '';

type ApiRequestProps = {
	version?: string;
	auth?: boolean;
};

export const onSuccess = function (response: any) {
	return response.data;
};

export const onError = function (error: any) {
	if (!(error.response && error.response.config.url === '/investor/login/email-code')) {
		if (error.response?.status === 401) {
			onForbidden();
		}
	}
	throw error;
};

export class ApiRequest {
	static create(version = 'v1') {
		return  axios.create({
			baseURL: `${apiUrl}/${version}`,
			headers: getDefaultHeaders(),
		})
	}
	static getInstance({ version = 'v1', auth }: ApiRequestProps) {
		if (!axiosInstances[version]) {
			const instance = ApiRequest.create(version);
			instance.interceptors.response.use(onSuccess, onError);
			instance.interceptors.request.use((config) => {
				return verifyJWT(config).then(({ headers }) => ({
					...config,
					headers,
				}))
			});
			axiosInstances[version] = instance;
		}
		return axiosInstances[version];
	}
}
